import { MessageCircle } from "lucide-react";
import { WA_LINK } from "@/lib/api";

export const WhatsAppFloat = () => (
  <a
    href={WA_LINK}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat WhatsApp Admin 082393244452"
    className="fixed bottom-5 right-5 z-50 group flex items-center gap-0 rounded-full bg-[#25D366] p-4 shadow-2xl shadow-emerald-950/60 transition-all duration-300 hover:scale-105"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" aria-hidden="true" />
    <MessageCircle size={24} className="text-white relative" fill="white" />
    <span className="max-w-0 overflow-hidden group-hover:max-w-[180px] transition-all duration-500 whitespace-nowrap">
      <span className="pl-2.5 pr-1 text-sm font-semibold text-white">082393244452</span>
    </span>
  </a>
);
